
<span
  #viewVotePopover="ngbPopover"
  [ngbPopover]="viewVotePopoverContent"
  placement="left"
  autoClose="true"
  triggers="manual"
></span>

<ng-template #viewVotePopoverContent>
  <div class="flex flex-col w-full h-full gap-2">
    <div class="flex flex-row w-full">
      <span [id]="id + '-title'" class="body-default-bold">{{
        popoverTitle
      }}</span>
    </div>
    <div
      class="flex flex-col w-full overflow-y-scroll"
      *ngIf="votePopoverItems && votePopoverItems.length > 0"
      tabindex="0"
    >
      <ng-container *ngFor="let item of votePopoverItems">
        <mat-divider class="mb-1 border-gray-300"></mat-divider>
        <div class="flex flex-row flex-wrap items-center w-full gap-2">
          <div class="flex flex-row items-center gap-2">
            <span
              [id]="id + '-vote-icon'"
              class="body-default-regular material-symbols-rounded"
              [style.color]="item.voteOption.color"
              >{{ item.voteOption.icon }}</span
            >
            <span class="body-default-regular" [id]="id + '-vote-text'"
              >{{ item.voteOption.text }} &nbsp; - &nbsp;</span
            >
          </div>
          <span class="body-default-regular" [id]="id + '-vote-date'">
            placed on
            {{ item.voteSubmittedDate | dateFormat:'dd MMM yyyy HH:mm' }}</span
          >
        </div>

        <div
          class="flex"
          *ngIf="item.additionalComments && item.additionalComments.length > 0"
        >
          <span
            class="body-default-regular"
            [id]="id + '-additional-comments'"
            >{{ item.additionalComments }}</span
          >
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
